import * as React from 'react'
import { FOOTER } from '../../utils/dataTrackingValues'

import Brandy from '../Brandy'
import Link from '../Link'

import * as Styled from './Footer.styles'
import * as StyledModule from './FooterModule.styles'

const Footer = ({
  bottomSectionModule = null,
  requestId,
  logo = null,
  logoLink = null,
  CustomLink = null,
  disclaimers = [],
  disclaimerBackgroundColor = null,
  disclaimerTextColor = null,
  logoBackgroundColor = null,
  logoBottomBorder = null,
  logoTextColor = null,
  logoTopBorder = null,
  navData = [],
  navigationBackgroundColor = null,
  navigationTextColor = null,
  topSectionModule = null,
}) => {
  const navBackgroundColor = navigationBackgroundColor?.toLowerCase() || ''
  const navTextColor = navigationTextColor?.toLowerCase() || ''
  const discTextColor = disclaimerTextColor?.toLowerCase() || ''
  const discBackgroundColor = disclaimerBackgroundColor?.toLowerCase() || ''
  const imageBackgroundColor = logoBackgroundColor?.toLowerCase() || ''
  const imageTextColor = logoTextColor?.toLowerCase() || ''
  const logoTopBorderValue = logoTopBorder?.toLowerCase() || ''
  const logoBottomBorderValue = logoBottomBorder?.toLowerCase() || ''
  const FooterLink = CustomLink || Link

  return (
    <Styled.Footer
      className="leshen-footer"
      navigationBackgroundColor={navBackgroundColor}
    >
      <Styled.TopSection
        className="top-section"
        logoBackgroundColor={imageBackgroundColor}
        logoTextColor={imageTextColor}
        logoTopBorder={logoTopBorderValue}
        logoBottomBorder={logoBottomBorderValue}
      >
        <Link to={`${logoLink || '#'}`}>
          {React.isValidElement(logo) ? logo : <span>{logo}</span>}
        </Link>

        {topSectionModule && (
          <StyledModule.TopSection className="top-section-right">
            {topSectionModule}
          </StyledModule.TopSection>
        )}
      </Styled.TopSection>

      {navData.length > 0 && (
        <Styled.BottomSection
          className="bottom-section"
          navigationBackgroundColor={navBackgroundColor}
          navigationTextColor={navTextColor}
        >
          {navData.map(({ text, href, link, subnav = [] }) => (
            <Styled.Nav key={text} className="nav">
              <Styled.GroupLabel variant="feature">
                {href ? (
                  <FooterLink to={href || link}>{text}</FooterLink>
                ) : (
                  text
                )}
              </Styled.GroupLabel>
              {subnav.map(
                ({ link: subnavLink, href: subnavHref, text: subNavText }) => {
                  const subHref = subnavLink || subnavHref
                  return (
                    <FooterLink
                      className="link"
                      key={subNavText}
                      to={subHref}
                      onClick={FOOTER?.LINKS?.handleClick?.(
                        subHref,
                        subNavText,
                        requestId
                      )}
                    >
                      {subNavText}
                    </FooterLink>
                  )
                }
              )}
            </Styled.Nav>
          ))}
          {bottomSectionModule && (
            <StyledModule.BottomSection
              className="bottom-right"
              navigationBackgroundColor={navigationBackgroundColor}
              navigationTextColor={navigationTextColor}
            >
              {bottomSectionModule}
            </StyledModule.BottomSection>
          )}
        </Styled.BottomSection>
      )}

      {disclaimers && disclaimers.length > 0 && (
        <Styled.LegalSection
          disclaimerBackgroundColor={discBackgroundColor}
          disclaimerTextColor={discTextColor}
          className="legal-section"
        >
          {disclaimers?.map((disclaimer) => (
            <Brandy
              className="brandy"
              key={disclaimer?.id}
              text={disclaimer?.text}
              symbol={disclaimer?.symbol}
              variant="legal"
            />
          ))}
        </Styled.LegalSection>
      )}
    </Styled.Footer>
  )
}

export default Footer
